<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.study profile") }}</h2>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12 px-2">
      <div
        class="mt-3 d-flex justify-content-between align-items-center"
        v-if="
          rollsprivilages.includes('Study Profile Edit Study') ||
          rollsprivilages.includes('Study Profile Create Version')
        "
      >
        <h4 class="sec-title">{{ $t("navigations.study information") }}</h4>

        <div class="d-flex align-items-center">
          <div class="me-3">
            <label class="mb-0 me-2">{{ $t("navigations.version") }}</label>
            <select
              class="form-select form-select-sm d-inline-block w-auto py-0"
              v-model="selectedVersion"
              @change="onVersionChange"
            >
              <option v-for="ver in versionList" :key="ver" :value="ver">
                {{ ver }}
              </option>
            </select>
          </div>
          <div
            class="position-relative align-self-center mr-3"
            style="padding-bottom: 3px"
            v-if="rollsprivilages.includes('Study Profile Create Version')"
            aria-label="Create version"
            tabindex="0"
          >
            <img
              width="17"
              height="17"
              class="cursor-pointer"
              src="../../assets/img/create.png"
              alt="Create version"
              @click="openVersionModal"
            />
            <div class="tool-tip">{{ $t("navigations.create version") }}</div>
          </div>
          <span
            class="position-relative"
            style="padding-bottom: 3px"
            v-if="rollsprivilages.includes('Study Profile Edit Study')"
            @click.prevent="studyEditModal = true"
          >
            <img
              width="17"
              height="17"
              class="cursor-pointer"
              src="../../assets/img/edit_doc.png"
              alt="Create version"
            />
            <div class="tool-tip">{{ $t("navigations.edit study") }}</div>
          </span>
        </div>
      </div>

      <!-- <hr class="my-1" /> -->
      <div class="card px-2 py-1">
        <div class="row">
          <div class="col-sm-2 border-right">
            <small class="stats-label">{{ $t("navigations.study id") }}</small>
            <h4>{{ studyDetails.studyRef }}</h4>
          </div>
          <div class="col-sm-3 border-right">
            <small class="stats-label">{{ $t("navigations.name") }}</small>
            <h4>{{ studyDetails.studyName }}</h4>
          </div>
          <div class="col-sm-2 border-right">
            <small class="stats-label">{{ $t("navigations.sponsor") }}</small>
            <h4>{{ studyDetails.sponsor }}</h4>
          </div>
          <div class="col-sm-2 border-right">
            <small class="stats-label">{{
              $t("navigations.expected no of sites")
            }}</small>
            <h4>{{ studyDetails.numberOfSite }}</h4>
          </div>
          <div class="col-sm-2 border-right">
            <small class="stats-label">{{
              $t("navigations.expected no of patients")
            }}</small>
            <h4>{{ studyDetails.numberOfPatient }}</h4>
          </div>
          <div class="col-sm-1">
            <small class="stats-label">{{ $t("navigations.status") }}</small>
            <h4>{{ studyDetails.status }}</h4>
          </div>
        </div>
      </div>
      <!-- <hr class="my-1" /> -->
    </div>
    <div class="col-lg-12 mt-2 px-2">
      <div class="px-0">
        <div class="btn-group w-100">
          <button
            class="btn btn-success btn-rounded btn-outline btn-xs mx-1"
            data-toggle="modal"
            data-target="#importForms"
            v-if="rollsprivilages.includes('Study Profile Import Forms')"
            @click.prevent="showFormsModal = true"
          >
            <i class="fa fa-download mr-1"></i>
            <span class="bold">{{ $t("navigations.import forms") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            @click.prevent="soAPopup(0)"
            data-toggle="modal"
            data-target="#createTemplate"
            v-if="rollsprivilages.includes('Study Profile Create Activity')"
          >
            <i class="fa fa-file-text-o mr-2"></i>
            <span class="bold">{{ $t("navigations.create activity") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            data-toggle="modal"
            data-target="#createVisit"
            v-if="isArmSpecific && rollsprivilages.includes('Study Profile SoA')"
            @click.prevent="routeToSoa()"
          >
           <i class="fa fa-sitemap mr-1"></i>
            <span class="bold">{{ $t("navigations.soa") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            data-toggle="modal"
            data-target="#createVisit"
            v-if="!isArmSpecific && rollsprivilages.includes('Study Profile SoA')"
            @click.prevent="routeToVisit()"
          >
            <i class="fa fa-sitemap mr-1"></i>
            <span class="bold">{{ $t("navigations.soa") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            data-toggle="modal"
            data-target="#createSite"
            v-if="rollsprivilages.includes('Study Profile Create Site')"
            @click.prevent="openSiteScreen()"
          >
            <i class="fa fa-hospital-o mr-1"></i>
            <span class="bold">{{ $t("navigations.create site") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            v-if="rollsprivilages.includes('Study Profile Create Subject')"
            @click.prevent="showPatientModal = true"
          >
            <i class="fa fa-user-o mr-1"></i>
            <span class="bold">{{ $t("navigations.create subject") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            @click.prevent="createTemplate()"
            data-toggle="modal"
            v-if="rollsprivilages.includes('Study Profile Create Form')"
            data-target="#createTemplate"
          >
            <i class="fa fa-file-text-o mr-2"></i>
            <span class="bold">{{ $t("navigations.create form") }}</span>
          </button>
          <button
            class="btn btn-success btn-outline btn-xs mx-1"
            @click.prevent="privilegeform()"
            data-toggle="modal"
            data-target="#createTemplate"
            v-if="rollsprivilages.includes('Study Profile Add Form Privilege')"
          >
            <i class="fa fa fa-plus-square-o mr-2"></i>
            <span class="bold">{{ $t("navigations.add form privilege") }}</span>
          </button>
          <!-- <button class="btn btn-success btn-outline btn-xs mx-1" data-toggle="modal" data-target="#createTemplate"
            @click.prevent="onClickButton">
            <i class="fa fa-file-text-o mr-2"></i>
            <span v-if="showLoadingAnimation">
              <img src="../../assets/img/loading.webp" width="20" class="loading-img" alt="Waiting for login" />
            </span>
            <span v-else class="bold">AI Forms</span>
          </button> -->
        </div>
      </div>
    </div>

    <div class="col-lg-12 wrapper wrapper-content px-2">
      <div class="card px-2 py-2">
        <h4>{{ $t("navigations.ecrf") }}</h4>
        <div class="text-center" v-if="ecrfLoading === true">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>
        <template v-else>
          <div class="text-center" v-if="studyTemplates.length == 0">
            {{ $t("navigations.no data available") }}
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered ibox-body">
              <thead>
                <tr>
                  <th
                    v-if="selectedcolumnobj['Category']"
                    class="sort_block"
                    @click="SortSelected('category', 5)"
                    id="5"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.category") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['Form Name']"
                    class="sort_block"
                    @click="SortSelected('templateName', 1)"
                    id="1"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.form name") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['Version']"
                    class="sort_block"
                    @click="SortSelected('version', 2)"
                    id="2"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.version") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['Language']"
                    class="sort_block"
                    @click="SortSelected('language', 3)"
                    id="3"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.language") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['Status']"
                    class="sort_block"
                    @click="SortSelected('status', 6)"
                    id="6"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.status") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['Last updated']"
                    class="sort_block"
                    @click="SortSelected('createdDate', 4)"
                    id="4"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.last updated") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>

                  <th
                    class="text-center"
                    v-if="
                      rollsprivilages.includes('Visit Templates View Template')
                    "
                  >
                    {{ $t("navigations.view") }}
                  </th>
                  <th class="text-center"
                   v-if="
                      rollsprivilages.includes('Study Profile Ecrf Actions')
                    "
                  >{{ $t("navigations.action") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(template, index) in studyTemplates"
                  :key="template.id"
                >
                  <td v-if="selectedcolumnobj['Category']">
                    {{ template.category }}
                  </td>
                  <td v-if="selectedcolumnobj['Form Name']">
                    {{ template.templateName }}
                  </td>
                  <td v-if="selectedcolumnobj['Version']">
                    {{ template.version }}
                  </td>
                  <td v-if="selectedcolumnobj['Language']">
                    {{ template.language }}
                  </td>
                  <td v-if="selectedcolumnobj['Status']">
                    {{ template.status }}
                  </td>
                  <td v-if="selectedcolumnobj['Last updated']">
                    {{ filterDate(template.createdDate) }}
                  </td>

                  <td
                    class="text-center"
                    v-if="
                      rollsprivilages.includes('Visit Templates View Template')
                    "
                  >
                    <a
                      @click.prevent="
                        viewtemplatefun(template.templateId, template.version)
                      "
                    >
                      <i class="fa fa-eye editicon"></i
                    ></a>
                  </td>
                  <td
                   v-if="
                         rollsprivilages.includes('Study Profile Ecrf Actions')
                       "
                    class="text-center"
                    v-on:clickout="showSidePopup[index] = false"
                  >
                    <div
                      class="position-relative cursor-pointer"
                    
                      @click.prevent="
                        showSidePopup[index] = !showSidePopup[index]
                      "
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </div>
                    <div class="plan-side-popup" v-if="showSidePopup[index]">
                      <div
                        v-if="
                          rollsprivilages.includes(
                            'Visit Templates Create New Version'
                          )
                        "
                        @click.prevent="
                          createNewVersion(
                            template.templateFormId,
                            template.version,
                            template.sourceTemplateId,
                            template.templateId,
                            template.therapeuticAreaId,
                            template.categoryId
                          )
                        "
                      >
                        {{ $t("navigations.create new version") }}
                      </div>
                      <div
                        @click.prevent="
                          openCategoryModal(
                            template.templateId,
                            template.category
                          )
                        "
                      >
                        {{ $t("navigations.change category") }}
                      </div>
                      <div
                        v-if="
                          rollsprivilages.includes(
                            'Visit Templates Retire Form'
                          )
                        "
                        @click.prevent="
                          openretireModal(
                            template.sourceTemplateId,
                            template.version
                          )
                        "
                      >
                        {{ $t("navigations.retire form") }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="col-lg-12 d-flex justify-content-lg-end px-0"
            v-if="studyTemplates.length != 0"
          >
            <v-pagination
              v-model="currentTemplatePage"
              :pages="totalTemplatePages"
              :range-size="0"
              active-color="#f4f9ff"
              @update:modelValue="loadTemplate"
            />
          </div>
        </template>
      </div>
    </div>
    <div class="col-lg-6 wrapper wrapper-content px-2">
      <VisitActivityTree 
        v-if="!isArmSpecific"
        :key="selectedVersion" 
        :version="selectedVersion"
        :optionsshow=true
      />
      <SoaTree 
        v-if="isArmSpecific"
        :key="selectedVersion" 
        :isArmSpecific="true"
        :version="selectedVersion"
      />
    </div>
    <div class="col-lg-6 wrapper wrapper-content px-2">
      <div class="card px-2 py-2">
        <h4>{{ $t("navigations.activities") }}</h4>
        <div class="text-center" v-if="activitiesLoading === true">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>
        <template v-else>
          <div class="text-center" v-if="SoAList.length == 0">
            {{ $t("navigations.no data available") }}
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered ibox-body">
              <thead>
                <tr>
                  <th
                    v-if="selectedcolumnobj['Activity Name']"
                    class="sort_block"
                    @click="SortActivities('activityName', 8)"
                    id="8"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.activity name") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['Activity Type']"
                    class="sort_block"
                    @click="SortActivities('activityType', 9)"
                    id="9"
                  >
                    <div class="d-flex flex-row justify-content-between">
                      {{ $t("navigations.activity type") }}
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th
                    v-if="selectedcolumnobj['View Form']"
                    class="sort_block"
                    @click="SortActivities('viewForms', 10)"
                    id="10"
                  > 
                    <div class="text-center">
                      {{ $t("navigations.view forms") }}
                    </div>
                  </th>
                  <th v-if="rollsprivilages.includes('Study Profile Activities-Action')" class="text-center">{{ $t("navigations.action") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in SoAList" :key="item.id">
                  <td v-if="selectedcolumnobj['Activity Name']">
                    {{ item.activityName }}
                  </td>
                  <td v-if="selectedcolumnobj['Activity Type']">
                    {{ item.activityType }}
                  </td>
                  <td class="text-center" v-if="selectedcolumnobj['View Form']">
                    <a
                      href="#"
                      @click.prevent="openActivityFormsModal(item.id)"
                    >
                      <i class="fa fa-eye editicon"></i>
                    </a>
                    {{ item.templateName }}
                  </td>
                  <td
                  v-if="rollsprivilages.includes('Study Profile Activities-Action')"
                    class="text-center"
                    v-on:clickout="showSoaPopup[index] = false"
                  >
                    <div
                      class="position-relative cursor-pointer" 
                      @click.prevent="
                        showSoaPopup[index] = !showSoaPopup[index]
                      "
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </div>
                    <div class="plan-side-popup" v-if="showSoaPopup[index]">
                      <div @click.prevent="deleteSoA(item.id, index)">
                        {{ $t("navigations.delete") }}
                      </div>
                      <div @click.prevent="soAPopup(item.id)">
                        {{ $t("navigations.edit") }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="col-lg-12 d-flex justify-content-lg-end px-0"
            v-if="SoAList.length != 0"
          >
            <v-pagination
              v-model="soaCurrentPage"
              :pages="soaTotalPages"
              :range-size="0"
              active-color="#f4f9ff"
              @update:modelValue="loadSoA"
            />
          </div>
        </template>
      </div>
    </div>

    <!-- <div class="col-lg-6 wrapper wrapper-content px-2">
      <div class="card px-2 py-2">
      <h4>{{ $t("navigations.visits") }}</h4>
      <div class="text-center" v-if="visitsLoading === true">
      <img
          src="../../assets/img/loading.gif"
          width="15"
          class=""
          alt="Waiting for login"
      />
      <div>
          {{ $t("navigations.please wait while the list is being loaded") }}
      </div>
      </div>    
      <template v-else>
        <div class="text-center" v-if="visitList.length==0">
            {{ $t('navigations.no data available') }}
        </div>   
        <div class="table-responsive" v-else>
          <table class="table table-striped table-bordered ibox-body">
            <thead>
              <tr>
                <th v-if="selectedcolumnobj['Visit No']" class="sort_block" @click="SortVisit('visitNo', 7)" id="7">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.visit no") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th v-if="selectedcolumnobj['Visit Name']" class="sort_block" @click="SortVisit('visitFormName', 6)"
                  id="6">
                  <div class="d-flex flex-row justify-content-between">
                    {{ $t("navigations.visit name") }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>             
                <th class="text-center">{{ $t("navigations.visit activity") }}</th>
                <th class="text-center">{{ $t("navigations.action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(visit, index) in visitList" :key="visit.visitId">
                <td v-if="selectedcolumnobj['Visit No']">{{ visit.visitNo }}</td>
                <td v-if="selectedcolumnobj['Visit Name']">
                  {{ visit.visitFormName }}
                </td>             
                <td class="text-center">
                  <i class="fa fa-clock-o edit-delete" @click.prevent="openVisitActivityModal(visit.visitId)"></i>
                </td>
                <td class="text-center" v-on:clickout="showVisitPopup[index] = false">
                  <div class="position-relative cursor-pointer" @click.prevent="
                    showVisitPopup[index] = !showVisitPopup[index]
                    ">
                    <i class="fa fa-ellipsis-v"></i>
                  </div>
                  <div class="plan-side-popup" v-if="showVisitPopup[index]" :id="`visit-${visitId}`">
                    <div v-if="rollsprivilages.includes('Visit Delete')" @click.prevent="deleteVist(visit.visitId)">
                      {{ $t("navigations.delete") }}
                    </div>
                    <div v-if="rollsprivilages.includes('Visit Edit')" @click.prevent="
                      visitPopup(visit.visitId, `visit-${visitId}`)
                      ">
                      {{ $t("navigations.edit") }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-12 d-flex justify-content-lg-end px-0" v-if="visitList.length!=0">
          <v-pagination v-model="currentVisitiPages" :pages="totalVisitPages" :range-size="0" active-color="#f4f9ff"
            @update:modelValue="loadVisit" />
        </div>
      </template>
      </div>
    </div> -->
  </div>
  <!-- <teleport to="#wrapper">
    <managePatientModal
      v-if="showPatientModal"
      @closeModal="showPatientModal = false"
      :patientId="0"
    />
  </teleport> -->
  <manageSubjectModal v-if="showPatientModal"
   @closeModal="showPatientModal = false"
    :patientId="0">
</manageSubjectModal>
  <importForms
    v-if="showFormsModal"
    @closeModal="showFormsModal = false"
    @importForms="listStudyTemplate()"
  />
  <manageVisitModal
    v-if="showSiteModal"
    :visitId="visitId"
    :version="selectedVersion"
    @closeModal="closeModal()"
    @visitSaved="openVisitActivityModal"
  />
  <manageSoAModal
    v-if="showSoAModal"
    :soAId="activityId"
    :studyId="studyDetails.studyId"
    :studyRef="studyDetails.studyRef"
    @closeSoAModal="closeSoAModal()"
    @refreshActivities="listSOAs"
  />
  <CreateSitePopUp
    v-if="siteModal"
    :userid="'0'"
    @closeModal="siteModal = false"
  />
  <EditStudyPopUp
    v-if="studyEditModal"
    :studyid="studyId"
    :selectedversion="selectedVersion"
    @studyChanged="getStudyDetails()"
    @closeModal="studyEditModal = false"
  />
  <createnewversion
    v-if="creatversionpopup == true"
    @closedialogebox="closecreatenewversion()"
    @createnewtempversion="newtemplateversion()"
    :templateId="currenttemplateId"
    :currentversion="currentformversion"
    :formid="newversionformid"
  />
  <versionpopup
    v-if="openCreateVersionModal == true"
    :studyid="studyId"
    :versiondetails="versiondetailsobj"
    @gotocreateNewVersion="gotocreateNewVersionfun()"
    @closeModal="closeVersion()"
  />
  <retireFormPopUp
    v-if="retireFormModal"
    @closeModal="closeRetireModal()"
    :sourceid="sourceId"
    :version="sourceVersion"
  />
  <ChangeCategory
    v-if="showcategoryModal"
    :templateId="selectedTemplateId"
    :selectedCategory="selectedCategory"
    @closeModal="closeCategoryModal()"
  />
  <teleport v-if="showAssignTemplate" to="#wrapper">
    <!-- Template modal starts -->
    <div class="study_profile_modal__wrapper">
      <div class="study_profile_modal__container custom-width mt-5">
        <div class="modal__title d-flex justify-content-between py-2 px-3">
          <h4 class="my-0">{{ $t("navigations.assign form") }}</h4>

          <div
            class="tooltip-wrapper pointer"
            @click.prevent="closeTemplateModal()"
            style="float: right"
          >
            <i class="fa fa-times cursor-pointer"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </div>
        </div>
        <div class="modal-body">
          <div>
            <div class="form-group row my-lg-2">
              <div class="d-flex justify-content-center">
                <div class="col-lg-10 pl-0 pr-1">
                  <Multiselect
                    v-model="selectedTemplateIds"
                    mode="multiple"
                    :searchable="true"
                    trackBy="templateName"
                    valueProp="templateId"
                    placeholder="Select Form"
                    label="templateName"
                    :options="templatelist"
                    :hideSelected="false"
                    :closeOnSelect="false"
                    class="multiselect-template-theme mr-0"
                  >
                    <template v-slot:option="{ option }">
                      {{ option.templateName }} ({{ option.version }})- {{ option.languageCode.toUpperCase() }}
                    </template>
                  </Multiselect>
                </div>
                <div class="col-lg-2 px-0">
                  <button
                    class="save_btn py-1 w-100"
                    @click.prevent="assignTemplate()"
                  >
                    {{ $t("navigations.assign") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal ends -->
  </teleport>
  <teleport v-if="addPrivilegeModal" to="#wrapper">
    <!-- Template modal starts -->
    <div class="study_profile_modal__wrapper">
      <div
        class="study_profile_modal__container PrivilegeModal-custom-width mt-5"
      >
        <div class="modal__title d-flex justify-content-between py-2 px-3">
          <h4 class="my-0">{{ $t("navigations.add form privilege") }}</h4>

          <div
            class="tooltip-wrapper pointer"
            @click.prevent="closePrivilege()"
            style="float: right; cursor: pointer"
          >
            <i class="fa fa-times"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </div>
        </div>
        <div class="modal-body">
          <div class="form-group row my-lg-2 d-flex">
            <div class="col-lg-6">
              {{ $t("navigations.select forms") }}
              <Multiselect
                v-model="selectedTemplateIds"
                mode="multiple"
                :searchable="true"
                trackBy="templateName"
                valueProp="templateId"
                placeholder="Select Template"
                label="templateName"
                :options="templates"
                :hideSelected="false"
                :closeOnSelect="false"
                class="multiselect-template-theme mr-0 mt-1"
                @change="onTemplateChange"
              >
              </Multiselect>
            </div>
            <div class="col-lg-6">
              Select Roles
              <Multiselect
                v-model="selectedRoleList"
                mode="multiple"
                :searchable="true"
                trackBy="roleName"
                valueProp="roleID"
                placeholder="Select Role"
                label="roleName"
                :options="roleList"
                :hideSelected="false"
                :closeOnSelect="false"
                class="multiselect-template-theme mr-0 mt-1"
                @change="onRoleChange"
              >
              </Multiselect>
            </div>
          </div>
          <div
            class="table-responsive"
            style="max-height: 300px; overflow-y: auto"
          >
            <table class="table table-striped table-bordered table-hover mb-0">
              <thead class="thead-light">
                <tr>
                  <th scope="col">Role</th>
                  <th scope="col">e-CRF</th>
                  <th scope="col">
                    Add
                    <br />
                    <input
                      type="checkbox"
                      :checked="isAllSelected('Add')"
                      @change="toggleColumn('Add', $event)"
                    />
                  </th>
                  <th scope="col">
                    Edit
                    <br />
                    <input
                      type="checkbox"
                      :checked="isAllSelected('Edit')"
                      @change="toggleColumn('Edit', $event)"
                    />
                  </th>
                  <th scope="col">
                    View
                    <br />
                    <input
                      type="checkbox"
                      :checked="isAllSelected('View')"
                      @change="toggleColumn('View', $event)"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in privilegeRows"
                  :key="row.roleId + '-' + row.templateId"
                >
                  <td>{{ row.roleName }}</td>
                  <td>{{ row.templateName }}</td>
                  <td>
                    <input
                      type="checkbox"
                      :checked="
                        rolesAndPrivilegelist[row.roleId][
                          row.templateId
                        ].includes('Add')
                      "
                      @change="onPrivilegeChange(row, 'Add', $event)"
                      value="Add"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      :checked="
                        rolesAndPrivilegelist[row.roleId][
                          row.templateId
                        ].includes('Edit')
                      "
                      @change="onPrivilegeChange(row, 'Edit', $event)"
                      value="Edit"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      :checked="
                        rolesAndPrivilegelist[row.roleId][
                          row.templateId
                        ].includes('View')
                      "
                      @change="onPrivilegeChange(row, 'View', $event)"
                      value="View"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-12 text-center py-2">
            <button
              v-if="addPrivilegebutton"
              class="save_btn py-1"
              :disabled="isCreating"
              @click.prevent="createFormPrivilege()"
            >
              <span
                v-if="isCreating"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {{
                isCreating
                  ? $t("creating…")
                  : $t("navigations.create privilege")
              }}
            </button>
            <!-- <button
              v-else
              class="save_btn py-1"
              @click.prevent="updateFormPrivilege()"
            >
              {{ $t("navigations.update privilege") }}
            </button> -->
            <button
              v-else
              class="save_btn py-1"
              :disabled="isUpdating"
              @click.prevent="updateFormPrivilege()"
            >
              <span
                v-if="isUpdating"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {{
                isUpdating
                  ? $t("updating…")
                  : $t("navigations.update privilege")
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal ends -->
  </teleport>
  <Forms_AI_PopUp
    v-if="AIpopup"
    @studyCreated="loadstudy"
    @closeModal="AIpopup = false"
  />

  <Teleport v-if="showVisitForms" to="#wrapper">
    <div class="study_profile_modal__wrapper">
      <div class="study_profile_modal__container custom-width mt-5">
        <div class="modal__title d-flex justify-content-between py-1 px-3">
          <h4 class="mb-0">{{ $t("navigations.forms") }}</h4>
          <div class="col-lg-2">
            <span class="tooltip-wrapper pointer" style="float: right">
              <i
                class="fa fa-times cursor-pointer"
                @click.prevent="closeModalForms"
              ></i>
              <span class="custom-tooltip closetooltipposition">Close</span>
            </span>
          </div>
        </div>
        <div class="modal-body overflow-block-form scroll_horizontal">
          <!-- test -->
          <div>
            <div class="form-group row my-lg-2">
              <div class="d-flex flex-column flex-lg-row mb-lg-0">
                <div class="col-lg-12">
                  <table class="table features-table">
                    <p v-if="formItems == ''" class="mb-0 text-center">
                      {{ $t("navigations.no forms added") }}
                    </p>
                    <tbody>
                      <tr v-for="forms in formItems" :key="forms.id">
                        <td>{{ forms.templateName }} ({{ forms.version }}) - {{ forms.languageCode.toUpperCase() }}</td>
                        <td class="text-center">
                          <i
                            class="fa fa-eye edit-delete"
                            @click.prevent="viewForm(forms.template_ID)"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-- test -->
        </div>
      </div>
    </div>
  </Teleport>
  <Teleport v-if="showActivityForms" to="#wrapper">
    <div class="study_profile_modal__wrapper">
      <div class="study_profile_modal__container custom-width mt-5">
        <div class="modal__title d-flex justify-content-between py-1 px-3">
          <h4 class="mb-0">{{ $t("navigations.forms") }}</h4>
          <div class="closebutton">
            <span class="tooltip-wrapper pointer" style="float: right">
              <i
                class="fa fa-times cursor-pointer"
                @click.prevent="closeActivityForms"
              ></i>
              <span class="custom-tooltip closetooltipposition">Close</span>
            </span>
          </div>
        </div>

        <div class="modal-body overflow-block-form scroll_horizontal">
          <div class="form-group row my-lg-2">
            <div class="d-flex flex-column flex-lg-row mb-lg-0">
              <div class="col-lg-12">
                <table class="table features-table">
                  <p
                    v-if="!soAItem.eCRF || soAItem.eCRF.length === 0"
                    class="mb-0 text-center"
                  >
                    {{ $t("navigations.no forms added") }}
                  </p>
                  <tbody>
                    <tr v-for="(form, index) in soAItem.eCRF" :key="index">
                      <td>{{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}</td>
                      <td class="text-center">
                        <i
                          class="fa fa-eye edit-delete"
                          @click.prevent="gotoform(form.templateId)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>

  <VisitActivityModal
    v-if="showActivityModal"
    :visitId="SelectedVisitId"
    :version="selectedVersion"
    :fromPage="'studyProfile'"
    @closeModal="showActivityModal = false"
  />
  <ActivityFormTemplate
    v-if="showActivityFormModal"
    :activityId="selectedActivityId"
    @closeModal="showActivityModal = false"
  />
  <showformmodel
    v-if="setshowActivityFormModal"
    :formid="currentform"
    currentformstatus="not completed"
    @closeformModal="closeformActivityModal()"
  />
</template>

<script src="./Study_Profile.js"></script>

<style scoped>
.btn-success {
  background-color: transparent;
  border-color: var(--secondary-clr);
  border-radius: 0;
  font-size: 0.8rem;
}

.btn-success:hover,
.btn-success:focus {
  color: #fff;
  background-color: #1a7bb9;
  border-color: #1a7bb9;
}

.btn {
  padding-block: 0.2rem;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 56px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}
.closetooltipposition {
  bottom: -10px !important;
  margin-left: -75px !important;
}

.plan-side-popup > div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup > div:hover {
  background-color: #e4eaf9;
}

.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  position: fixed;
  border-radius: 4px;
  background: #fff;
}

.modal__title {
  background-color: var(--pop-up-background);
  color: white;
  border: 0px;
  border-radius: 4px 4px 0px 0px;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.float-right:hover .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.custom-width {
  width: min(500px, 90%);
}

.PrivilegeModal-custom-width {
  width: min(900px, 90%);
}

.modal-wrapper-forms {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  z-index: 3000;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  margin: 0;
  padding: 5%;
}

.multiselect-template-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
  --ms-radius: 0;
  --ms-line-height: 0.8;
  --ms-option-font-size: 0.8rem;
  --ms-font-size: 0.8rem;
}
.closetooltipposition {
  bottom: -10px !important;
  margin-left: -75px !important;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.scroll_horizontal {
  height: 400px;
  overflow: auto;
}
.btn-group > .btn {
  font-size: 0.8rem;
  font-weight: 400px;
  border-radius: 4px !important;
  border-color: var(--primary-clr);
}
.card h4 {
  font-size: 13px !important;
  font-weight: 600;
}
.sec-title {
  font-size: 13px !important;
  font-weight: 600;
}
</style>
